export function normalizeURL(url?: string) {
  let actualUrl = url

  if (!actualUrl) {
    try {
      actualUrl = window.location.href
    } catch {
      actualUrl = ''
    }
  }

  return actualUrl.toLowerCase()
}
